module.exports = __webpack_public_path__ + "img/img22.6d60bc29.svg";